/** The eight-step engagement workflow rendered by the interactive timeline. */

export const processSteps = [
  {
    id: 1,
    icon: 'ClipboardEdit',
    title: 'Submit Pickup Request',
    duration: 'Day 0',
    summary:
      'Share your company details, waste categories and approximate quantity through the request form or your account manager.',
    details: [
      'Online form, email or a call to your named manager',
      'Photographs of the lot help us quote faster',
      'Instant acknowledgement with a request reference ID',
    ],
  },
  {
    id: 2,
    icon: 'SearchCheck',
    title: 'Verification & Quotation',
    duration: 'Within 24 hrs',
    summary:
      'Our team validates the inventory, confirms the applicable waste streams and shares a transparent buy-back or service quotation.',
    details: [
      'Category-wise rate card shared upfront',
      'Virtual or on-site survey for large lots',
      'Formal work order raised on approval',
    ],
  },
  {
    id: 3,
    icon: 'CalendarClock',
    title: 'Pickup Scheduled',
    duration: 'Within 48 hrs',
    summary:
      'A collection slot is locked with vehicle, crew and packaging assigned. Gate passes and site permissions are arranged in advance.',
    details: [
      'Vehicle and crew details shared before arrival',
      'Gate pass and security documentation prepared',
      'Sealed bins delivered for large consignments',
    ],
  },
  {
    id: 4,
    icon: 'PackageCheck',
    title: 'Material Collection',
    duration: 'Pickup day',
    summary:
      'Assets are counted, tagged, sealed and loaded under your supervision. You receive a signed manifest before the vehicle departs.',
    details: [
      'Item-wise counting and serial capture',
      'Tamper-evident sealing of containers',
      'Signed chain-of-custody manifest on the spot',
    ],
  },
  {
    id: 5,
    icon: 'Recycle',
    title: 'Recycling & Recovery',
    duration: 'Day 3 – Day 7',
    summary:
      'At facility, material is weighed, de-polluted, dismantled and mechanically separated into recoverable fractions.',
    details: [
      'Weighbridge entry and intake reconciliation',
      'De-pollution of hazardous fractions',
      'Shredding, separation and metal recovery',
    ],
  },
  {
    id: 6,
    icon: 'FileCheck2',
    title: 'Compliance Documentation',
    duration: 'Day 7 – Day 10',
    summary:
      'Form 6 is issued, passbook entries are made against your producer ID and every statutory record is filed on the CPCB portal.',
    details: [
      'Form 6 issuance per consignment',
      'Passbook entry against your producer ID',
      'Manifest and weighbridge records archived',
    ],
  },
  {
    id: 7,
    icon: 'Award',
    title: 'Certificates Issued',
    duration: 'Day 10 – Day 12',
    summary:
      'Recycling certificates and serial-wise data destruction certificates are delivered to your compliance and IT teams.',
    details: [
      'Recycling certificate with quantities by stream',
      'Serial-wise Certificate of Data Destruction',
      'CO₂-avoided summary for ESG reporting',
    ],
  },
  {
    id: 8,
    icon: 'CircleCheckBig',
    title: 'EPR Credits Completed',
    // duration: 'Day 12 – Day 15',
    summary:
      'Credits are generated against your EPR target, reconciled on the portal and confirmed back to you — obligation closed.',
    details: [
      'Credit generation against your EPR target',
      'Portal reconciliation and confirmation',
      'Obligation status updated in your dashboard',
    ],
  },
];

/** Documents a client receives at the end of an engagement. */
export const deliverableDocs = [
  {
    icon: 'FileText',
    name: 'Form 6',
    description: 'Statutory record of e-waste handed to an authorised recycler.',
  },
  {
    icon: 'BookMarked',
    name: 'Passbook Entry',
    description: 'Quantity credited against your producer ID on the CPCB portal.',
  },
  {
    icon: 'Award',
    name: 'Recycling Certificate',
    description: 'Stream-wise proof of environmentally sound processing.',
  },
  {
    icon: 'ShieldCheck',
    name: 'Data Destruction Certificate',
    description: 'Serial-wise confirmation of NIST 800-88 sanitisation.',
  },
  {
    icon: 'Truck',
    name: 'Chain-of-Custody Manifest',
    description: 'Signed movement record from your gate to our weighbridge.',
  },
  {
    icon: 'Scale',
    name: 'Weighbridge Slip',
    description: 'Independent weight capture at facility intake.',
  },
  {
    icon: 'LineChart',
    name: 'ESG Impact Summary',
    description: 'CO₂ avoided and materials recovered, ready for your report.',
  },
];

/** Response-time commitments shown alongside the workflow. */
export const slaCommitments = [
  { label: 'Quotation turnaround', value: '24 hours' },
  { label: 'Pickup after approval', value: '48 working hours' },
  { label: 'Documentation delivery', value: '7 working days' },
  // { label: 'EPR credit reflection', value: '10–15 days' },
];
